var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9342 1.71094H6.04199L11.9904 12.0141L17.9342 1.71094Z",
    fill: "url(#paint0_linear_3344_32560)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9345 1.71094L11.9907 12.0141L17.9345 22.3125L23.8829 12.0141L17.9345 1.71094Z",
    fill: "url(#paint1_linear_3344_32560)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04238 1.71094L0.0986328 12.0141L6.04236 22.3125L11.9908 12.0141L6.04238 1.71094Z",
    fill: "url(#paint2_linear_3344_32560)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9904 12.0142L6.04199 22.3126H17.9342L11.9904 12.0142Z",
    fill: "url(#paint3_linear_3344_32560)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3344_32560",
    x1: 11.9895,
    y1: 12.1739,
    x2: 11.9895,
    y2: 1.23738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#73C2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6EB9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#66AAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5A95FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F80FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3344_32560",
    x1: 11.9771,
    y1: 12.0124,
    x2: 24.0409,
    y2: 12.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96D4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42C0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3344_32560",
    x1: 0.0971328,
    y1: 12.0124,
    x2: 11.9899,
    y2: 12.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4E7FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4A7CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#4477E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#3C6FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3166B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B60A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3344_32560",
    x1: 11.9895,
    y1: 11.4964,
    x2: 11.9895,
    y2: 22.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#73C2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6EB9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#66AAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5A95FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F80FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDec);
export default __webpack_public_path__ + "static/media/dec.3ac0f0c7ad19753227a8343155eb70c4.svg";
export { ForwardRef as ReactComponent };